import { render, staticRenderFns } from "./ListMedtuteur.vue?vue&type=template&id=ff029e8a&"
import script from "./ListMedtuteur.vue?vue&type=script&lang=js&"
export * from "./ListMedtuteur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports